import { getIcon } from 'components/Table/Modifiers';

import { UseInfiniteSource } from 'components/Table/Source';
import { ColumnSettingsAction } from './CollectionActions/Record/ColumnSettingsAction';
import { Box } from '@fluentui/react-northstar';
import { RefreshListAction } from './CollectionActions/Record/RefreshListAction';

export enum ColumnAlign {
	center = 'center',
	left = 'left',
	right = 'right'
}

export enum Customizable {
	readonly = 'readonly',
	orderonly = 'orderonly',
	full = 'full'
}

type ComplexLabel = {
	value: Function,
	title?: string,
	align?: ColumnAlign
};

export type ColumnLayout = {
	width: number | 'auto',
	order: string,
	exists?: boolean,
	label?: string | ComplexLabel,
	value?: Function,
	align?: ColumnAlign,
	customizable: string
};

export type ListLayout = {
	columns: { [column: string]: ColumnLayout },
	data?: string[]
};

function GetDefaultLayout(): { [collection: string]: ListLayout }
{
	return {
		Records: {
			columns: {
				icon: {
					exists: false,
					width: 50,
					order: '0',
					label: 'Type',
					value: (record: any) => getIcon(record.Document?.Extension),
					customizable: Customizable.readonly
				},
				ID: {
					width: 80,
					order: '1',
					label: 'ID',
					customizable: Customizable.full
				},
				Title: {
					width: 'auto',
					order: '2',
					label: 'Title',
					customizable: Customizable.orderonly
				},
				State_Summary: {
					exists: true,
					width: 160,
					order: '3',
					label: 'State',
					customizable: Customizable.full
				},
				empty: {
					exists: false,
					width: 80,
					customizable: Customizable.readonly,
					label: '',
					order: '9999998'
				},
				action: {
					exists: false,
					width: 80,
					align: ColumnAlign.right,
					order: '9999999',
					label: {
						value: (source: UseInfiniteSource) =>
						<Box>
							<RefreshListAction source={source} title='Refresh the list' />
							<ColumnSettingsAction source={source} title='Column settings' />
						</Box>,
						align: ColumnAlign.right
					},
					customizable: Customizable.readonly
				}
			},
			data: [
				'Locked',
				'State_Value',
				'File/Closed',
				'HasWritePermission',
				'ThrashedBy_Value',
				'DocumentFormat/Kind_Value',
				'Document/Extension',
				'RecordType_Value',
				'RecordNo',
				'RetentionPolicy/RetentionPolicy/CommentRequired'
			]
		}
	};
}

export default GetDefaultLayout;
